import React from 'react'

import ContactForm from '../../../react4xp/components/ContactForm'

function ContactFormPart({
    strings,
    sendEmailServiceUrl,
    termsAndConditionsUrl,
    products,
    user,
    recaptcha,
}) {
    return (
        <ContactForm
            sendEmailServiceUrl={sendEmailServiceUrl}
            termsAndConditionsUrl={termsAndConditionsUrl}
            strings={strings}
            user={user}
            products={products}
            recaptcha={recaptcha}
        />
    )
}

export default (props) => <ContactFormPart {...props} />
